/* ============================================================
   Night Mode — pure resolver + no-flash bootstrap.
   Loaded synchronously in <head> (applies saved state before
   first paint). Also requirable in Node for unit tests.
   ============================================================ */
(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) {
    module.exports = api; // Node (unit tests)
  } else {
    root.NightMode = api; // Browser
    api.applyInitial();   // no-flash: set initial veil state before paint
  }
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var DEFAULTS = { nightMode: "off", warmth: "neutral", dimming: "medium" };

  var WARMTH_RGB = {
    neutral: "8, 8, 12",
    warm: "30, 18, 6",
    warmer: "48, 26, 6"
  };

  var DIMMING_ALPHA = {
    light: 0.18,
    medium: 0.3,
    heavy: 0.44
  };

  var STORAGE_KEYS = {
    nightMode: "tgd-night-mode",
    warmth: "tgd-night-warmth",
    dimming: "tgd-night-dimming"
  };

  function pick(value, table, fallback) {
    return Object.prototype.hasOwnProperty.call(table, value) ? value : fallback;
  }

  // Pure: (prefs, prefersDark) -> { on, rgb, alpha }
  function resolve(prefs, prefersDark) {
    prefs = prefs || {};
    var nightMode =
      prefs.nightMode === "on" ||
      prefs.nightMode === "off" ||
      prefs.nightMode === "auto"
        ? prefs.nightMode
        : DEFAULTS.nightMode;
    var warmth = pick(prefs.warmth, WARMTH_RGB, DEFAULTS.warmth);
    var dimming = pick(prefs.dimming, DIMMING_ALPHA, DEFAULTS.dimming);

    var on;
    if (nightMode === "on") on = true;
    else if (nightMode === "off") on = false;
    else on = !!prefersDark;

    return { on: on, rgb: WARMTH_RGB[warmth], alpha: DIMMING_ALPHA[dimming] };
  }

  // ---- Browser-only helpers (DOM-bound; verified manually) ----

  function readPrefs() {
    try {
      return {
        nightMode: localStorage.getItem(STORAGE_KEYS.nightMode),
        warmth: localStorage.getItem(STORAGE_KEYS.warmth),
        dimming: localStorage.getItem(STORAGE_KEYS.dimming)
      };
    } catch (e) {
      return {};
    }
  }

  function savePref(name, value) {
    try {
      localStorage.setItem(STORAGE_KEYS[name], value);
    } catch (e) {}
  }

  function prefersDark() {
    return (
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    );
  }

  function apply(state) {
    var el = document.documentElement;
    el.style.setProperty("--night-veil-rgb", state.rgb);
    el.style.setProperty("--night-veil-alpha", String(state.alpha));
    el.setAttribute("data-night", state.on ? "on" : "off");
  }

  function applyInitial() {
    apply(resolve(readPrefs(), prefersDark()));
  }

  return {
    DEFAULTS: DEFAULTS,
    WARMTH_RGB: WARMTH_RGB,
    DIMMING_ALPHA: DIMMING_ALPHA,
    STORAGE_KEYS: STORAGE_KEYS,
    resolve: resolve,
    readPrefs: readPrefs,
    savePref: savePref,
    prefersDark: prefersDark,
    apply: apply,
    applyInitial: applyInitial
  };
});
